import script from "./wOutboundDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./wOutboundDetail.vue?vue&type=script&setup=true&lang=ts"

import "./wOutboundDetail.vue?vue&type=style&index=0&id=e38fae9a&lang=scss"

const __exports__ = script;

export default __exports__